import React, { useEffect, useMemo } from 'react'
import { useInstData, useEventHandler } from 'tyan/public/hooks'
import { hasChangedValues, getFormValue, changeItemsValue, getChangedFieldsets } from 'tyan/public/utility'

const InstrumentUsageInfo = props => {
    const { setState, me } = useInstData(props, useMemo(() => ({
        state: {
            instrumentNumber: props.match.params.query,
            id: props.match.params.id || ''
        }
    }), []))

    const { showBody: Body } = props
    const { instrumentNumber, id } = me.state
    const bSave = /* id == 0 || */ true

    useEffect(() => {
        handleDidMount()
    }, [])

    const handleDidMount = () => {
        Tyan.doPostEvent('GetInstrumentUsageWx', {
            data: { instrumentNumber, id },
            onEnd: ({ errorMessage, optionsParas, initValues基本信息 }) => {
                if (errorMessage) {
                    Tyan.pubForm.showError(errorMessage)
                } else {
                    setState({ optionsParas, initValues基本信息, changedValues基本信息: {} })
                }
            }
        })
    }

    const handlerSave = () => {
        Tyan.doPostEvent('SaveInstrumentUsageWx', {
            data: { instrumentNumber, id, ...getChangedFieldsets(me, null, false) },
            onEnd: ({ errorMessage, optionsParas, initValues基本信息 }) => {
                if (errorMessage) {
                    Tyan.pubForm.showError(errorMessage)
                } else {
                    setState({ optionsParas, initValues基本信息, changedValues基本信息: {} })
                    handlerBack()
                }
            }
        })
    }

    const handlerDelete = () => {
        Tyan.pubForm.showConfirm('确定要删除？', () => {
            Tyan.doPostEvent('DelInstrumentUsageWx', {
                data: { id },
                onEnd: ({ errorMessage }) => {
                    if (errorMessage) {
                        Tyan.pubForm.showError(errorMessage)
                    } else {
                        handlerBack()
                    }
                }
            })
        })
    }

    const handlerBack = () => {
        const { instrumentNumber } = me.state
        location.hash = `/InstrumentUsageQuery/${instrumentNumber}`
    }

    const handlerClose = () => {
        window.history.back()
        //onClose()
    }



    return <Body data={me}
        controls={
            [
                { _button: '保存', icon: '', handler: handlerSave, cdt: () => bSave },
                { _button: '删除', icon: '', handler: handlerDelete, cdt: () => id != 0 },
                { _button: '返回', icon: '', handler: handlerBack },
                // { _button: '关闭', icon: '', handler: handlerClose },
            ]
        }
        fieldsets={
            [
                {
                    title: '', name: '基本信息', _fieldset: [
                        { _text: '设备编号', disabled: true, minWidth: '95%', },
                        { _text: '设备名称', disabled: true, minWidth: '95%', },
                        { _date: '最晚使用时间', disabled: true, minWidth: '95%', ui: 'red', },
                        { _text: '试验委托单编号', disabled: !bSave, minWidth: '95%' },
                        { _text: '测试项目', disabled: !bSave, minWidth: '95%' },
                        { _date: '开始时间', disabled: !bSave, minWidth: '95%' },
                        { _date: '结束时间', disabled: !bSave, minWidth: '95%' },
                        { _text: '使用人', disabled: !bSave, minWidth: '95%' },
                        { _text: '试验内容', disabled: !bSave, minWidth: '95%', maxRows: 5 },
                        { _html: '', name: '未完成内容', minWidth: '95%' },
                        // {
                        //     _grid: '', name: '未完成记录', rowNumbers: true, maxRows: 50,
                        //     columns: [
                        //         { _text: '委托编号', flex: 1, },
                        //         { _text: '测试项目', flex: 1, },
                        //         { _date: '开始时间', flex: 1, },
                        //         { _date: '结束时间', flex: 1, },
                        //         { _text: '使用人', flex: 1, },
                        //         { _text: '试验内容', flex: 1, },
                        //     ],
                        // }
                    ],
                },
            ]}
    />
}

export default InstrumentUsageInfo